import {redirect, useActionData} from "react-router-dom";
import FormDescription from "../../../components/Layout/FormDescription";
import FormContainer from "../../../components/Layout/FormContainer";
import ReasonCategoryForm, {formDataToReasonCategory} from "./ReasonCategoryForm";
import ReasonCategories from "../../../services/UkTreatmentApi/ReasonCategories";
import {useContext, useEffect} from "react";
import AlertContext from "../../../contexts/AlertContext";

export async function action({request}) {
    const formData = await request.formData();
    const reasonCategory = formDataToReasonCategory(formData);

    try {
        await ReasonCategories.create(reasonCategory);

        return redirect("/manage/reason_categories");
    } catch (error) {
        return error;
    }
}

const Create = () => {
    const {handleErrorAlert} = useContext(AlertContext);
    const actionError = useActionData();

    useEffect(() => {
        if (actionError) handleErrorAlert(actionError, "Failed data submission")
    }, [actionError, handleErrorAlert]);

    return <FormContainer>
        <div className="md:col-span-1">
            <FormDescription title="Reason Category" text="Register the reason category in the app."/>
        </div>

        <div className="mt-5 md:col-span-3 md:mt-0">
            <ReasonCategoryForm id="create-reason-category-form"/>
        </div>
    </FormContainer>;
}

export default Create;